/**
 * Parse int safe with a fallback
 * @param {string} numberlike
 * @param {number} fallback
 * @return {number}
 */
const parseIntSafe = (numberlike, fallback) => {
    const num = Number.parseInt(numberlike, 10);
    return Number.isNaN(num) ? fallback : num;
};

/**
 * Returns integer part of number described in compact notation
 * @param {number} num
 * @param {boolean} [isPercent=false]
 * @return {number}
 */
const getCompactIntegerPartLength = (num, isPercent = false) => {
    const THOUSAND = 1000;
    const number = isPercent ? num * 100 : num;
    const exponent = Math.floor(Math.log(number) / Math.log(THOUSAND));
    return Math.floor(number / THOUSAND ** exponent).toString().length;
};

export { parseIntSafe, getCompactIntegerPartLength };
